function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun-cloud-2908391",
  transform: "translate(-0.003700, 0.922600)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M437.9237,139.4374 C432.8846,139.4374 427.8457,139.99599 422.8027,140.5585 C414.9629,88.4805 369.6037,48.1605 315.2827,48.1605 C304.6417,48.1605 294.0017,49.8402 283.9237,52.641 C262.0837,20.719 225.1227,2.84217094e-14 183.6837,2.84217094e-14 C116.4847,2.84217094e-14 62.1637,54.32 62.1637,121.52 C62.1637,128.8012 62.72229,136.079 64.402,143.36 C26.879,156.798 0,192.079 0,233.52 C0,285.598 42,327.598 94.078,327.598 L438.478,327.598 C490.556,327.598 532.556,285.598 532.556,233.52 C532.556,181.438 490.001,139.438 437.923,139.438 L437.9237,139.4374 Z",
  id: "Path"
})));

var SvgAzure = function SvgAzure(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "533px",
    height: "329px",
    viewBox: "0 0 533 329",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAzure, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Azure.db58b863.svg";
export { ForwardRef as ReactComponent };